import { useCallback, useEffect, useState } from "react";
import { INITIAL_FORM, REQUIRED_FIELDS, isFilled } from "./careersConfig";

/**
 * useCareersForm — form state, per-field setter, and validation for the
 * careers application. Kept in isolation so section components stay dumb.
 *
 * `resetKey` is any value that, when it changes, forces the form back to
 * its initial state (used by the parent to react to `location.key`).
 */
export function useCareersForm(resetKey) {
  const [form, setForm] = useState(INITIAL_FORM);
  const [missing, setMissing] = useState([]);
  const [serverError, setServerError] = useState("");

  useEffect(() => {
    setForm(INITIAL_FORM);
    setMissing([]);
    setServerError("");
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [resetKey]);

  const set = useCallback((k, v) => {
    setForm((f) => ({ ...f, [k]: v }));
    setMissing((m) => (m.length ? m.filter((x) => x[0] !== k) : m));
  }, []);

  const validate = useCallback(() => {
    const missed = REQUIRED_FIELDS.filter(([k]) => !isFilled(form[k]));
    setMissing(missed);
    return missed;
  }, [form]);

  const isMissing = useCallback((k) => missing.some(([m]) => m === k), [missing]);

  return { form, set, missing, setMissing, serverError, setServerError, validate, isMissing };
}
